import styled, { css } from "styled-components";

import BlueFilledLeafMediumSrc from "../../assets/images/blue-filled-leaf-medium.png";
import BlueLeafSmallSrc from "../../assets/images/blue-leaf-small.png";
import BuyAnotherBedSrc from "../../assets/images/buy-another-bed.png";
import EvrgreenCommitmentSrc from "../../assets/images/evrgree-commitment.png";
import FactorySamplesSrc from "../../assets/images/factory-samples.png";
import GreenFilledLeafExtraSmallSrc from "../../assets/images/green-filled-leaf-extra-small.png";
import GreenRegularLeafSrc from "../../assets/images/regular-leaf-small.png";
import LightBlueFilledLeafSrc from "../../assets/images/light-blue-filled-leaf.png";
import NeverImgSrc from "../../assets/images/never.png";
import ShutterStockSrc from "../../assets/images/shutterstock.png";
import SquaresOfSquaresSrc from "../../assets/images/square-of-squares.png";
import TreeDeciduousRegularSrc from "../../assets/images/tree-deciduous-regular-big.png";
import UserGearRegularSrc from "../../assets/images/user-gear-regular-big.png";
import YesWeMeanItSrc from "../../assets/images/yes-we-mean-it.png";
import ReduceLogoSrc from "../../assets/images/reduce-logo.png";
import RecycleLogoSrc from "../../assets/images/recycle-logo.png";
import ReuseLogoSrc from "../../assets/images/reuse-logo.png";
import WorkerSrc from "../../assets/images/worker-mass-produce.png";
import DarkGreenFilledLeafLargeSrc from "../../assets/images/dark-green-filled-leaf-large.png";

export const NeverImg = styled.img.attrs({ src: NeverImgSrc })`
  height: 341px;
  width: 676px;
  margin-top: -130px;
  margin-left: 100px;
`;

export const BuyAnotherBed = styled.img.attrs({ src: BuyAnotherBedSrc })`
  height: 100px;
  width: 605px;
  margin-left: 180px;
  margin-top: -150px;
`;

export const YesWeMeanIt = styled.img.attrs({ src: YesWeMeanItSrc })`
  height: 57px;
  width: 348px;
  margin-left: 442px;
  margin-top: -78px;
`;

export const SquareOfSquaresSmall = styled.img.attrs({
  src: SquaresOfSquaresSrc,
})`
  height: 62px;
  width: 67px;
`;

const mainImageMargin = css`
  margin: 39px 71px 0 82px;
`;

export const SquareOfSquaresLarge = styled.img.attrs({
  src: SquaresOfSquaresSrc,
})`
  height: 146px;
  width: 157px;
  ${mainImageMargin}
`;

export const UserGearRegularSmall = styled.img.attrs({
  src: UserGearRegularSrc,
})`
  height: 60px;
  width: 75px;
`;

export const UserGearRegularLarge = styled.img.attrs({
  src: UserGearRegularSrc,
})`
  height: 127px;
  width: 160px;
  ${mainImageMargin}
`;

export const TreeDeciduousRegularSmall = styled.img.attrs({
  src: TreeDeciduousRegularSrc,
})`
  height: 75px;
  width: 75px;
`;

export const TreeDeciduousRegularLarge = styled.img.attrs({
  src: TreeDeciduousRegularSrc,
})`
  height: 133px;
  width: 133px;
  ${mainImageMargin}
`;

export const BlueLeafSmall = styled.img.attrs({
  src: BlueLeafSmallSrc,
})`
  height: 68px;
  width: 70px;
  margin-left: 180px;
  margin-top: 220px;
`;

export const GreenRegularLeaf = styled.img.attrs({
  src: GreenRegularLeafSrc,
})`
  height: 135px;
  width: 147px;
  margin-left: 275px;
  margin-top: -30px;
`;

export const GreenFilledLeafExtraSmall = styled.img.attrs({
  src: GreenFilledLeafExtraSmallSrc,
})`
  height: 57px;
  width: 72px;
  margin-left: 370px;
  margin-top: -40px;
`;

export const FactorySamples = styled.img.attrs({
  src: FactorySamplesSrc,
})`
  width: 521px;
  height: 392px;
  margin-left: 885px;
  margin-top: -90px;
`;

export const BlueFilledLeafMedium = styled.img.attrs({
  src: BlueFilledLeafMediumSrc,
})`
  height: 229px;
  width: 272px;
`;

export const LightBlueFilledLeaf = styled.img.attrs({
  src: LightBlueFilledLeafSrc,
})`
  height: 230px;
  width: 285px;
`;

export const ShutterStock = styled.img.attrs({
  src: ShutterStockSrc,
})`
  height: 405px;
  width: 610px;
`;

export const EvrgreenCommitment = styled.img.attrs({
  src: EvrgreenCommitmentSrc,
})`
  height: 95px;
  width: 312px;
  margin-top: 30px;
`;

export const ReuseLogo = styled.img.attrs({
  src: ReuseLogoSrc,
})`
  height: 55px;
  width: 72px;
`;

export const RecycleLogo = styled.img.attrs({
  src: RecycleLogoSrc,
})`
  height: 60px;
  width: 89px;
`;

export const ReduceLogo = styled.img.attrs({
  src: ReduceLogoSrc,
})`
  height: 46px;
  width: 70px;
`;

export const Worker = styled.img.attrs({
  src: WorkerSrc,
})`
  width: 611px;
  height: 265px;
  margin: 0;
`;

export const DarkGreenFilledLeafLarge = styled.img.attrs({
  src: DarkGreenFilledLeafLargeSrc,
})`
  width: 277px;
  height: 218px;
`;
